import React from 'react'
import PageHeader from '../components/common/PageHeader'
import Profile from '../components/content/profile'

const ProfilePage = () => {
  return (
    <>
      <Profile/>
    </>
  )
}

export default ProfilePage